import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaFacebookSquare, FaInstagramSquare, FaLinkedin, FaTwitterSquare } from 'react-icons/fa';

export default function Footer() {
    const { t } = useTranslation();
    return (
        <div className={'bg-SM-dark px-[10vw] py-10 text-white'}>
            <div className={'logo'}>SPRAWNE MIASTO</div>

            <div className={'mx-10 flex flex-wrap justify-center gap-10 py-12'}>
                <div className={' flex basis-full flex-col md:basis-1/4'}>
                    <h2 className={'mb-2 w-fit whitespace-nowrap text-2xl font-medium'}>
                        {t('translation:FOOTER.INFORMATION')}
                    </h2>
                    <Link to={'about-us'} className={'hover-effect w-fit'}>
                        {t('translation:FOOTER.ABOUT_US')}
                    </Link>
                    <Link to={'contact'} className={'hover-effect w-fit'}>
                        {t('translation:FOOTER.CONTACT')}
                    </Link>
                    <Link to={'partners'} className={'hover-effect w-fit'}>
                        {t('translation:FOOTER.PARTNERS')}
                    </Link>
                </div>

                <div className={' flex basis-full flex-col md:basis-1/4'}>
                    <h2 className={'mb-2 w-fit whitespace-nowrap text-2xl font-medium'}>
                        {t('translation:FOOTER.FOR_LOCAL_GOVERNMENTS')}
                    </h2>
                    <Link to={'how-it-works'} className={'hover-effect w-fit'}>
                        {t('translation:FOOTER.HOW_IT_WORKS')}
                    </Link>
                    <Link to={'partnership'} className={'hover-effect w-fit'}>
                        {t('translation:FOOTER.PARTNERSHIP')}
                    </Link>
                </div>

                <div className={' flex basis-full flex-col md:basis-1/4'}>
                    <h2 className={'mb-2 w-fit whitespace-nowrap text-2xl font-medium'}>
                        {t('translation:FOOTER.PRIVACY')}
                    </h2>
                    <Link to={'statute'} className={'hover-effect w-fit'}>
                        {t('translation:FOOTER.STATUTE')}
                    </Link>
                    <Link to={'statute/cookies'} className={'hover-effect w-fit'}>
                        {t('translation:FOOTER.INFORMATION_ABOUT_COOKIES')}
                    </Link>
                    <Link to={'statute/privacy'} className={'hover-effect w-fit'}>
                        {t('translation:FOOTER.PRIVACY_POLICY')}
                    </Link>
                </div>
            </div>

            <div className={'ml-1 flex gap-4 text-2xl'}>
                <a
                    href={'https://www.facebook.com/profile.php?id=100074261624293'}
                    className={'hover-effect'}
                    target={'_blank'}
                    rel={'noreferrer'}>
                    <FaFacebookSquare />
                </a>

                <a
                    href={'https://twitter.com/SMiasto'}
                    target={'_blank'}
                    rel={'noreferrer'}
                    className={'hover-effect'}>
                    <FaTwitterSquare />
                </a>
                <a
                    href={'https://www.instagram.com/sprawne_miasto/'}
                    target={'_blank'}
                    rel={'noreferrer'}
                    className={'hover-effect'}>
                    <FaInstagramSquare />
                </a>
                <a
                    href={'https://www.linkedin.com/company/sprawne-miasto/'}
                    target={'_blank'}
                    rel={'noreferrer'}
                    className={'hover-effect'}>
                    <FaLinkedin />
                </a>
            </div>
            <div className={'mt-4'}>© Sprawne Miasto {new Date().getFullYear()}</div>
        </div>
    );
}
